import { Chip } from '@/global/components/Chip'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'

export default function TipoEscala({ value }: GridCellParams) {
    return <Chip label={value} color="warning" className="w-full" />
}
